import { ReversalHistoryKey } from '../../TModules';

export const translations = {
  [ReversalHistoryKey]: {
    Title: 'Historique des annulations',
    Administrator: 'Administrateur',
    Source: 'Source',
    SourceTransactionReversal: 'Annulation de transaction',
    SourceBulkAction: 'Action groupée',
    StatusSuccess: 'Réussi',
    StatusFailed: 'Échoué',
    ExportCsv: 'Exporter en CSV',
    Campaign: 'Campagne',
    TicketCode: 'Code du ticket',
    Customer: 'Client',
    Reason: 'Motif',
    Outcome: 'Résultat',
    FailureMessage: 'Message d’erreur',
    ReversedOn: 'Annulé le',
    System: 'Système',
    FilterCampaign: 'Filtrer par campagne',
    FilterAdministrator: 'Filtrer par administrateur',
    FilterSource: 'Filtrer par source',
    FilterOutcome: 'Filtrer par résultat',
    ExportQueued: 'Export en file d’attente — nous enverrons le CSV à {{email}}'
  }
};
